import { PictureFormat } from './Picture.types';

export const MIME_TYPE = {
  [PictureFormat.PNG]: 'image/png',
  [PictureFormat.WEBP]: 'image/webp',
  [PictureFormat.JPEG]: 'image/jpeg',
  [PictureFormat.JPG]: 'image/jpeg',
  [PictureFormat.GIF]: 'image/gif',
  [PictureFormat.AVIF]: 'image/avif',
  [PictureFormat.SVG]: 'image/svg+xml',
};
